// assets/edm-bundle-ui-render-mobile.js
// Mobile-spezifische Rendering-Funktionen (Bottom Sheet, Sticky Bar, Modal)

window.EdumonBundle = window.EdumonBundle || {};

window.EdumonBundle.UIRenderMobile = {
  // --- Loading Overlay Helpers ---
  /**
   * Show mobile loading overlay
   * Context7: Single Source of Truth - Uses template HTML from Liquid (PDP or LP)
   * Both PDP and LP have identical HTML structure in their templates
   * This function only shows/hides the element, never creates duplicates
   */
  showMobileLoading: function() {
    // Context7: SOT - Always use template HTML from edm-bundle-builder-global.liquid
    // This element is globally available via theme.liquid for ALL pages (PDP, LP, Sticky)
    let el = document.getElementById('bb-mobile-loading');
    
    if (!el) {
      // Fallback: Create only if template HTML is missing (should not happen in production)
      console.warn('[Bundle Builder] Mobile loading overlay not found in template, creating fallback');
      const html = `
      <div id="bb-mobile-loading" class="bb-ml" role="dialog" aria-modal="true" aria-live="polite" hidden>
        <div class="bb-ml__panel" role="document">
          <div class="bb-ml__cards" aria-hidden="true">
            <span class="bb-ml__card"></span>
            <span class="bb-ml__card"></span>
            <span class="bb-ml__card"></span>
          </div>
          <p class="bb-ml__text">Booster wird gemischt …</p>
          <div class="bb-ml__bar"><span></span></div>
        </div>
      </div>
    `;
      document.body.insertAdjacentHTML('beforeend', html);
      el = document.getElementById('bb-mobile-loading');
    } else {
      // Context7: SOT - Element exists from template, ensure it's in the correct state
      // Reset animation if needed (for multiple uses)
      const bar = el.querySelector('.bb-ml__bar > span');
      if (bar) {
        // Reset progress bar animation by removing and re-adding the animation
        const currentWidth = bar.style.width;
        bar.style.width = '0%';
        bar.style.animation = 'none';
        // Force reflow to reset
        void bar.offsetWidth;
        // Restore animation
        bar.style.animation = '';
        bar.style.width = '';
      }
      
      // Ensure cards animation is running (CSS handles this, but we ensure visibility)
      const cards = el.querySelectorAll('.bb-ml__card');
      cards.forEach(card => {
        card.style.animation = 'none';
        void card.offsetWidth;
        card.style.animation = '';
      });
    }
    
    // Show the overlay (blurry background + animation)
    el.removeAttribute('hidden');
  },
  
  /**
   * Hide mobile loading overlay
   * Context7: Single Source of Truth - Works for both PDP and LP
   */
  hideMobileLoading: function() {
    const el = document.getElementById('bb-mobile-loading');
    if (el) {
      el.setAttribute('hidden', '');
      // Reset progress bar for next use
      const bar = el.querySelector('.bb-ml__bar > span');
      if (bar) {
        bar.style.width = '0%';
      }
    }
  },
  
  // --- Header Measurement (Sticky Offset) ---
  /**
   * Measure header bottom position for sticky offset
   */
  measureHeaderBottom: function() {
    const Config = window.EdumonBundle.Config;
    const header = document.querySelector(Config.SELECTORS.HEADER) || 
                   document.querySelector(Config.SELECTORS.STICKY_HEADER) || 
                   document.querySelector(Config.SELECTORS.HEADER_WRAPPER) ||
                   document.querySelector('header[role="banner"]');
    const rect = header ? header.getBoundingClientRect() : null;
    const offset = rect ? Math.max(0, rect.bottom) : 0;
    const cssVar = Config.CSS_VARS?.STICKY_TOP_OFFSET || '--sticky-top-offset';
    document.documentElement.style.setProperty(cssVar, offset + 'px');
  },
  
  /**
   * Schedule header measurement (debounced with RAF)
   */
  scheduleMeasureHeader: function() {
    const Config = window.EdumonBundle.Config;
    if (!this._measureRaf) {
      this._measureRaf = requestAnimationFrame(() => {
        this._measureRaf = null;
        this.measureHeaderBottom();
      });
    }
  },
  
  // --- Image Pre-Warming Helper ---
  /**
   * Preload sheet resources for better performance
   * @param {Element} sheet - Sheet element
   */
  preloadSheetResources: function(sheet) {
    if (!sheet) return;
    const images = Array.from(sheet.querySelectorAll('.bb-sheet__grid .bb-tile__imgwrap img'));
    const limit = Math.min(8, images.length); // Erste 8 Bilder
    
    for (let i = 0; i < limit; i++) {
      const img = images[i];
      if (img.loading === 'lazy') img.loading = 'eager';
      if (img.decode) img.decode().catch(() => {});
    }
  },
  
  // --- Sticky Gate Logic ---
  /**
   * Build ticks (tier markers) on sticky progress bar
   * @param {Element} stickyEl - Sticky element
   * @param {Array} tiers - Discount tiers
   * @param {number} maxSlots - Maximum slots
   */
  buildTicks: function(stickyEl, tiers, maxSlots) {
    const ticksWrap = stickyEl?.querySelector('[data-bb-ticks]');
    if (!ticksWrap) return;
    
    ticksWrap.innerHTML = '';
    tiers.forEach(t => {
      const span = document.createElement('span');
      // Calculate percentage position based on max slots
      const left = (t.qty / maxSlots) * 100;
      span.style.left = left + '%';
      span.textContent = `−${t.off}%`;
      ticksWrap.appendChild(span);
    });
  },
  
  /**
   * Apply mobile slot labels (using Tier %)
   * @param {Array} slots - Slot elements
   * @param {Array} tiers - Discount tiers
   */
  applyMobileSlotLabels: function(slots, tiers) {
    const Config = window.EdumonBundle.Config;
    const Utils = window.EdumonBundle.Utils;
    
    if (!Utils.isMobile()) return;
    
    slots.forEach((slot, i) => {
      const idx = i + 1;
      const label = slot.querySelector(Config.SELECTORS.LABEL);
      const off = tiers.find(t => t.qty === idx)?.off;
      if (label) {
        label.textContent = (typeof off !== 'undefined') ? `−${off}%` : String(idx);
      }
      slot.setAttribute('aria-label', `Slot ${idx}`);
    });
  },
  
  /**
   * Update sticky bar (Mobile)
   * @param {Element} stickyEl - Sticky element
   * @param {Object} state - State object
   * @param {Array} tiers - Discount tiers
   * @param {number} maxSlots - Maximum slots
   */
  updateStickyBar: function(stickyEl, state, tiers, maxSlots) {
    const Config = window.EdumonBundle.Config;
    if (!stickyEl) return;
    
    const stickyFillEl = stickyEl.querySelector('.bb-sticky__fill');
    const stickyTextEl = stickyEl.querySelector(Config.SELECTORS.STICKY_TEXT);
    
    const q = state.totalQty;
    const pct = Math.max(0, Math.min(100, (q / maxSlots) * 100));
    
    if (stickyFillEl) stickyFillEl.style.width = pct + '%';
    
    if (stickyTextEl) {
      // Compute short summary
      let nextTier = tiers.find(t => t.qty > q);
      let currentTier = null;
      for (const t of tiers) if (q >= t.qty) currentTier = t;
      
      let text = '';
      if (q === 0) {
        text = '0/10 Booster • ab 3 −10 %';
      } else if (!currentTier && nextTier) {
        text = `${q}/10 Booster • noch ${nextTier.qty-q} bis −${nextTier.off} %`;
      } else if (currentTier && nextTier) {
        text = `${q}/10 Booster • −${currentTier.off} % aktiv • noch ${nextTier.qty-q} bis −${nextTier.off} %`;
      } else if (currentTier && !nextTier) {
        text = `${q}/10 Booster • −${currentTier.off} % aktiv`;
      } else {
        text = `${q}/10 Booster`;
      }
      
      stickyTextEl.textContent = text;
    }
  },
  
  // --- Sheet Management ---
  /**
   * Update milestone chips (Mobile)
   * @param {number} qOverride - Quantity override (optional)
   * @param {Object} state - State object
   * @param {Array} tiers - Discount tiers
   * @param {Element} sheetEl - Sheet element
   */
  updateMilestoneChips: function(qOverride, state, tiers, sheetEl) {
    const Config = window.EdumonBundle.Config;
    const Utils = window.EdumonBundle.Utils;
    
    if (!Utils.isMobile()) return;
    if (!sheetEl) sheetEl = document.getElementById(Config.SELECTORS.SHEET);
    if (!sheetEl) return;
    
    const q = (typeof qOverride === 'number') ? qOverride : state.totalQty;
    const milestones = [0, ...tiers.map(t => t.qty)];
    const active = milestones.filter(m => q >= m).pop() ?? 0;
    sheetEl.querySelectorAll(Config.SELECTORS.MILESTONE_CHIP).forEach(chip => {
      chip.classList.toggle(Config.CLASSES.ACTIVE, Number(chip.dataset.m) === active);
    });
  },
  
  /**
   * Update sheet quantities (Mobile)
   * @param {Object} sheetItems - Sheet items {variantId: qty}
   * @param {Element} sheet - Sheet element
   */
  updateSheetQuantities: function(sheetItems, sheet) {
    const Config = window.EdumonBundle.Config;
    const SELECTORS = Config.SELECTORS;
    const CLASSES = Config.CLASSES;
    
    if (!sheet) return;
    
    sheet.querySelectorAll(SELECTORS.TILE).forEach(tile => {
      const vid = String(tile.dataset.variantId);
      const qty = sheetItems[vid] || 0;
      
      // Update data-qty attribute
      tile.setAttribute(Config.DATA_ATTRS.QTY, String(qty));
      
      const qtyEl = tile.querySelector(SELECTORS.STEPPER_QTY);
      const addBtn = tile.querySelector(SELECTORS.BTN_ADD);
      const stepper = tile.querySelector(SELECTORS.STEPPER);
      
      if (qty === 0) {
        // Initial-Zustand: Keine "0" anzeigen, nur Add-Button sichtbar
        if (qtyEl) qtyEl.textContent = '';
        if (addBtn) {
          addBtn.style.display = '';
          addBtn.removeAttribute('hidden');
        }
        if (stepper) {
          stepper.style.display = 'none';
          stepper.setAttribute('hidden', '');
        }
      } else {
        // qty > 0: Menge anzeigen, Stepper sichtbar, Add-Button versteckt
        if (qtyEl) qtyEl.textContent = String(qty);
        if (addBtn) {
          addBtn.style.display = 'none';
          addBtn.setAttribute('hidden', '');
        }
        if (stepper) {
          stepper.style.display = 'flex';
          stepper.removeAttribute('hidden');
        }
      }
    });
  },
  
  /**
   * Update sheet summary (Mobile)
   * @param {Object} sheetItems - Sheet items {variantId: qty}
   * @param {Array} tiers - Discount tiers
   * @param {number} maxSlots - Maximum slots
   * @param {Element} sheet - Sheet element
   */
  updateSheetSummary: function(sheetItems, tiers, maxSlots, sheet) {
    const Config = window.EdumonBundle.Config;
    const SELECTORS = Config.SELECTORS;
    const TEXTS = Config.TEXTS;
    
    if (!sheet) return;
    
    const total = Object.values(sheetItems).reduce((a, b) => a + b, 0);
    const countEl = sheet.querySelector(SELECTORS.SHEET_COUNT);
    const nextEl = sheet.querySelector(SELECTORS.SHEET_NEXT);
    
    if (countEl) countEl.textContent = TEXTS.COUNT_FORMAT(total, maxSlots);
    
    const next = tiers.find(t => t.qty > total);
    if (nextEl) {
      if (!total && next) {
        nextEl.textContent = TEXTS.NEXT_TIER_FORMAT(next.qty - total, next.off);
      } else if (next) {
        nextEl.textContent = TEXTS.NEXT_TIER_FORMAT(next.qty - total, next.off);
      } else {
        nextEl.textContent = TEXTS.TIER_MAX;
      }
    }
  },
  
  /**
   * Create variant tile element (for LP/Modal)
   * @param {Object} variant - Variant object
   * @param {Object} product - Product object (optional)
   * @returns {Element} Tile element
   */
  createVariantTile: function(variant, product = null) {
    const Config = window.EdumonBundle.Config;
    const Utils = window.EdumonBundle.Utils;
    const SELECTORS = Config.SELECTORS;
    const DATA_ATTRS = Config.DATA_ATTRS;
    
    const tile = document.createElement('div');
    tile.className = 'bb-tile';
    if (!variant.available) tile.classList.add(Config.CLASSES.DISABLED);
    tile.setAttribute(DATA_ATTRS.VARIANT_ID, variant.id);
    tile.setAttribute(DATA_ATTRS.QTY, '0');
    tile.setAttribute('role', 'listitem');
    
    // Image Wrap (exakt wie Liquid)
    const imgWrap = document.createElement('div');
    imgWrap.className = 'bb-tile__imgwrap';
    
    // Context7: Transform featured_media to featured_image for normalizeImageUrl
    // Wenn Variant-Daten aus AJAX kommen, können sie featured_media als Objekt haben
    // WICHTIG: featured_media wird von normalizeImageUrl bereits unterstützt (PRIORITY 1),
    // aber wenn variant.image leer ist und variant.featured_media fehlt, müssen wir sicherstellen,
    // dass variant.featured_image aus dem Original-Objekt verwendet wird
    const transformedVariant = { ...variant };
    
    // Wenn variant.image leer ist, aber variant.featured_media existiert, behalte featured_media
    // normalizeImageUrl wird featured_media als PRIORITY 1 verwenden
    if (!variant.image && variant.featured_media) {
      // featured_media wird bereits von normalizeImageUrl unterstützt, keine Transformation nötig
      // Aber sicherstellen, dass featured_media nicht überschrieben wird
    }
    
    // Wenn variant.image gesetzt ist, aber leer, und variant.featured_media existiert,
    // verwende featured_media statt leerem image
    if (variant.image === '' && variant.featured_media) {
      // Entferne leeres image, damit normalizeImageUrl featured_media verwendet
      delete transformedVariant.image;
    }
    
    // Nutze normalizeImageUrl für robuste Bild-Extraktion
    // normalizeImageUrl unterstützt jetzt featured_media direkt (PRIORITY 1)
    const imgSrc = Utils.normalizeImageUrl(transformedVariant, product);
    if (imgSrc) {
      const img = document.createElement('img');
      img.src = imgSrc;
      img.alt = variant.title || '';
      img.loading = 'lazy';
      img.decoding = 'async';
      imgWrap.appendChild(img);
    }
    
    // Info Container (exakt wie Liquid - KEINE details/title/price)
    const info = document.createElement('div');
    info.className = 'bb-tile__info';
    
    // Add Button (exakt wie Liquid)
    const addBtn = document.createElement('button');
    addBtn.className = 'bb-btn-add';
    addBtn.type = 'button';
    addBtn.setAttribute('aria-label', 'Hinzufügen');
    addBtn.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>';
    
    // Stepper (exakt wie Liquid)
    const stepper = document.createElement('div');
    stepper.className = 'bb-stepper';
    stepper.setAttribute('aria-label', 'Menge anpassen');
    stepper.style.display = 'none';
    
    const minusBtn = document.createElement('button');
    minusBtn.className = 'bb-stepper__btn bb-stepper__minus';
    minusBtn.type = 'button';
    minusBtn.setAttribute(SELECTORS.STEPPER_MINUS.replace('[', '').replace(']', ''), '');
    minusBtn.setAttribute('aria-label', 'Weniger');
    minusBtn.textContent = '−';
    
    const qtyOutput = document.createElement('output');
    qtyOutput.className = 'bb-stepper__qty';
    qtyOutput.setAttribute(SELECTORS.STEPPER_QTY.replace('[', '').replace(']', ''), '');
    qtyOutput.textContent = '0';
    
    const plusBtn = document.createElement('button');
    plusBtn.className = 'bb-stepper__btn bb-stepper__plus';
    plusBtn.type = 'button';
    plusBtn.setAttribute(SELECTORS.STEPPER_PLUS.replace('[', '').replace(']', ''), '');
    plusBtn.setAttribute('aria-label', 'Mehr');
    plusBtn.textContent = '+';
    
    stepper.appendChild(minusBtn);
    stepper.appendChild(qtyOutput);
    stepper.appendChild(plusBtn);
    
    // Struktur exakt wie Liquid: info enthält nur addBtn und stepper
    info.appendChild(addBtn);
    info.appendChild(stepper);
    
    // Struktur exakt wie Liquid: tile enthält imgWrap und info
    tile.appendChild(imgWrap);
    tile.appendChild(info);
    
    return tile;
  },
  
  // --- Modal Management ---
  /**
   * Update modal quantities
   * @param {Object} modalItems - Modal items {variantId: qty}
   * @param {Element} grid - Grid element
   */
  updateModalQuantities: function(modalItems, grid) {
    const Config = window.EdumonBundle.Config;
    const SELECTORS = Config.SELECTORS;
    
    if (!grid) return;
    
    grid.querySelectorAll(SELECTORS.TILE).forEach(tile => {
      const vid = String(tile.dataset.variantId);
      const qtyEl = tile.querySelector(SELECTORS.STEPPER_QTY);
      if (qtyEl) qtyEl.textContent = String(modalItems[vid] || 0);
    });
  },
  
  /**
   * Update modal milestones
   * @param {Object} modalItems - Modal items {variantId: qty}
   * @param {Array} tiers - Discount tiers
   * @param {Element} modal - Modal element
   */
  updateModalMilestones: function(modalItems, tiers, modal) {
    const Config = window.EdumonBundle.Config;
    const SELECTORS = Config.SELECTORS;
    const CLASSES = Config.CLASSES;
    
    if (!modal) return;
    
    const total = Object.values(modalItems).reduce((a, b) => a + b, 0);
    
    // Get tier for quantity
    let tier = null;
    for (let i = tiers.length - 1; i >= 0; i--) {
      if (total >= tiers[i].qty) {
        tier = tiers[i];
        break;
      }
    }
    
    modal.querySelectorAll('.bb-chip').forEach(chip => {
      const m = parseInt(chip.dataset.m || '0', 10);
      if (m === 0) {
        chip.classList.toggle(CLASSES.ACTIVE, total === 0);
      } else {
        chip.classList.toggle(CLASSES.ACTIVE, tier && tier.qty === m);
      }
    });
  },
  
  // --- Slot Management ---
  /**
   * Update slot interactivity (Delegates to UIRenderShared)
   * Context7: Platform Separation - Shared logic moved to UIRenderShared
   * This is a wrapper for backward compatibility
   * 
   * @param {Array} slots - Slot elements
   * @param {boolean} isMobile - Whether mobile viewport
   */
  updateSlotInteractivity: function(slots, isMobile) {
    const UIRenderShared = window.EdumonBundle.UIRenderShared;
    if (UIRenderShared && UIRenderShared.updateSlotInteractivity) {
      return UIRenderShared.updateSlotInteractivity(slots, isMobile);
    }
    console.warn('[Bundle Builder] UIRenderShared.updateSlotInteractivity not available');
  }
};
